import { AccessPermissionsEnum } from '@/router/constants';

export default [
  {
    routeName: 'main',
    text: 'leftSideMenu.main',
    icon: 'r-home',
    permissions: [
      AccessPermissionsEnum.CAN_READ_MAIN,
      AccessPermissionsEnum.CAN_READ_MAIN_STATISTICS_WIDGETS,
    ],
    place: 'top',
    paths: [],
    routeNames: ['main'],
  },
  {
    routeName: 'wallet',
    text: 'leftSideMenu.pselection',
    icon: 'medal-star',
    roles: ['admin'],
    permissions: [AccessPermissionsEnum.CAN_READ_PSELECTION, AccessPermissionsEnum.CAN_READ_WALLET],
    place: 'top',
    paths: ['wallet'],
    group: 'restaurant',
    routeNames: ['wallet', 'loyalty', 'bonus', 'discount'],
  },
  {
    routeName: 'points',
    text: 'leftSideMenu.pointsOfSale',
    icon: 'map-pin-line',
    roles: ['admin'],
    permissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
    place: 'top',
    paths: ['points'],
    group: 'restaurant',
    routeNames: ['points', 'points:list', 'points:workTime', 'points:departments', 'new-point', 'edit-point'],
  },
  {
    routeName: 'catalog:settings',
    text: 'leftSideMenu.catalog',
    icon: 'qr-code',
    permissions: [AccessPermissionsEnum.CAN_READ_CATALOG_POINTS],
    place: 'top',
    paths: ['catalog'],
    group: 'restaurant',
    routeNames: ['catalog', 'catalog:settings', 'catalog:additives', 'catalog:qrcode', 'new-product', 'edit-product'],
  },
  {
    text: 'leftSideMenu.staff',
    routeName: 'staff:list',
    icon: 'three-users',
    permissions: [AccessPermissionsEnum.CAN_READ_STAFF],
    place: 'top',
    paths: ['staff'],
    group: 'personal',
    routeNames: [
      'staff',
      'staff:list',
      'staff:calls',
      'staff:tasks',
      'staff:news',
      'staff:notifications',
      'feedbacks:staff',
      'new-employee',
      'edit-employee',
      'new-task',
      'edit-task',
      'new-news',
      'edit-news',
      'new-notifications',
      'edit-notifications',
      'feedbacks-view',
      'staff:calls:hall',
      'staff:calls:hall:edit',
      'staff:calls:shift',
      'staff:calls:shift:edit',
    ],
  },
  {
    routeName: 'crm',
    text: 'leftSideMenu.crm',
    icon: 'crm',
    permissions: [AccessPermissionsEnum.CAN_READ_CRM],
    place: 'top',
    paths: ['crm'],
    group: 'guests',
    routeNames: [
      'crm',
      'crm:clients',
      'crm:push',
      // Temporarily hidden until certificates are implemented.
      // Restore this route name when returning certificates to the admin panel.
      // 'crm:certificates',
      'crm:template',
      'crm:trigger',
      'crm:orders',
      'crm:kitchen',
      'crm:feedbacks',
    ],
  },
  {
    routeName: 'broadcast',
    text: 'leftSideMenu.broadcast',
    icon: 'broadcast',
    permissions: [AccessPermissionsEnum.CAN_READ_CRM],
    place: 'top',
    paths: ['broadcast'],
    group: 'personal',
    routeNames: ['broadcast', 'broadcast:stat', 'broadcast:template', 'broadcast:trigger'],
  },
  {
    routeName: 'statistic',
    text: 'leftSideMenu.statistic',
    icon: 'statistic',
    permissions: [AccessPermissionsEnum.CAN_READ_STATISTIC],
    place: 'top',
    paths: ['/statistic'],
    group: 'restaurant',
    routeNames: [
      'statistic',
      'statistic:satisfaction',
      'statistic:average-check',
      'statistic:top-selling',
      'statistic:retention',
      'statistic:transaction',
      'statistic:employee-rating',
      'statistic:employee-details',
      'statistic:employee-check-details',
    ],
  },
  {
    routeName: 'integrations',
    text: 'leftSideMenu.integrations',
    icon: 'puzzle',
    roles: ['admin'],
    permissions: [AccessPermissionsEnum.CAN_READ_INTEGRATIONS],
    place: 'bottom',
    paths: ['integrations'],
    group: 'bottom',
    routeNames: ['integrations', 'integrations:default', 'integrations:article'],
  },
  {
    routeName: 'faq:default',
    text: 'leftSideMenu.faq',
    icon: 'info',
    permissions: [AccessPermissionsEnum.CAN_READ_FAQ],
    place: 'bottom',
    paths: ['faq'],
    group: 'bottom',
    routeNames: ['faq', 'faq:default', 'faq:article'],
  },
  {
    routeName: 'support',
    text: 'leftSideMenu.support',
    icon: 'gear',
    permissions: [AccessPermissionsEnum.CAN_READ_SUPPORT],
    place: 'bottom',
    paths: ['support'],
    group: 'bottom',
    routeNames: ['support', 'support:default', 'support:article'],
  },
];
